<template>
  <b-modal :active="value" @close="$emit('input', false)" :width="850" scroll="keep">
    <div class="card">
      <div class="card-content">
        <h2 class="title is-4 has-text-info">
          <font-awesome-icon icon="circle-info" class="mr-2"/>
          Event Context
        </h2>
        <div class="content">
          <p>
            The following attributes were collected as potentially relevant context,
            accurate at the time of the notification.
          </p>
          <div class="buttons mb-2">
            <CopyLink @click="copyJson" label="Copy notification" variant="info" class="mr-2">
              Copy as JSON
            </CopyLink>
            <!-- exclusion policy buttons -->
            <b-button v-if="!selectionMode" @click="selectionMode = true">Select</b-button>
            <b-button type="is-danger is-outlined" 
              v-if="selectionMode && selectedProperties.length > 0"
              @click="newExclusionPolicy"
              >New exclusion policy&hellip;</b-button>
            <!-- exclusion policy buttons -->
          </div>
        </div>

        <NotificationAttributes title="Context" :attributes="otherAttributes" :selectable="selectionMode" v-model="selectedProperties" :n="n"/>
        <AttributeTable title="Policy" :attributes="policyAttributes" :selectable="selectionMode" v-model="selectedProperties" class="mt-6"/>
        <AttributeTable title="Device" :attributes="deviceAttributes" :selectable="selectionMode" v-model="selectedProperties" class="mt-6"/>
        <AttributeTable title="Location" :attributes="locationAttributes" :selectable="selectionMode" v-model="selectedProperties" class="mt-6"/>
        <AttributeTable title="App" :attributes="apkAttributes" :selectable="selectionMode" v-model="selectedProperties" class="mt-6"/>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { copyText } from '@/services/browser/copy'
import { others, group } from '@/services/context'
import { procedureNewExclusionPolicy } from '@/services/api/notifications/exclusions'

export default {
  emits: ["input"],
  props: {
    n: Object,
    value: Boolean,
  },
  data () {
    return {
      selectionMode: false,
      selectedProperties: []
    }
  },
  computed: {
    apkAttributes () { return group('apk', this.n.metaData) },
    deviceAttributes () { return group('device', this.n.metaData) },
    policyAttributes () { return group('policy', this.n.metaData) },
    locationAttributes () { return group('location', this.n.metaData) },
    otherAttributes () { return others(this.n.metaData) },
  },
  methods: {
    copyJson () {
      copyText(JSON.stringify(this.n, {}, 2), 'Copied JSON', this)
    },
    async newExclusionPolicy () {
      await procedureNewExclusionPolicy(this, this.n, this.selectedProperties)
      this.selectionMode = false
      this.selectedProperties = []
    }
  }
};
</script>